// extracted by mini-css-extract-plugin
export default {"marker":"Marker_marker__tmvEj","popup":"Marker_popup__zT37-"};